import { agentHost } from './AgentHost';
import { apiKeys } from './ApiKeys';
import { announcements } from './Announcements';
import { organisationNodes } from './OrganisationNodes';
import { jobArchitecture } from './jobArchitecture';
import { payEquityAudit } from './payEquityAudit';
import { login } from './login';
import { baseRegistry } from './baseRegistry';
import { roleAccess } from './RoleAccess';
import { dataImport } from './DataImport';
import { customEmployment } from './customEmployment';
import { scim } from './Scim';
import { legalEntities } from './legalEntities';
import { countrySettings } from './countrySettings';
import { users } from './users';
import { involveReportEmployeeSearch } from './InvolveReportEmployeeSearch';
import { salaryReview } from './SalaryReview';
import { sectionManager } from './sectionManager';
import { managers } from './managers';

export const api = {
    agentHost,
    apiKeys,
    announcements,
    payEquityAudit,
    baseRegistry,
    customEmployment,
    dataImport,
    legalEntities,
    countrySettings,
    involveReportEmployeeSearch,
    login,
    organisationNodes,
    jobArchitecture,
    roleAccess,
    salaryReview,
    scim,
    users,
    sectionManager,
    managers,
};
